<template>
    <vue-seamless-scroll
        :data="analysedata"
        :class-option="optionHover"
        class="seamless-warp"
    >
        <ul class="item">
            <li v-for="(item, index) in analysedata" :key="index">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content username">
                            {{ item.username }}
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="grid-content mName">
                            {{ item.mName }}
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content mName">
                            {{ item.date }}
                        </div>
                    </el-col>
                </el-row>
            </li>
        </ul>
    </vue-seamless-scroll>
</template>
<style lang="scss" scoped>
.seamless-warp {
    height: 88%;
    overflow-y: hidden;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 0;
    color: #fff;
    .item {
        li {
            border-bottom: 1px dashed #70b4eb;
        }
    }

    .grid-content{
        padding: 12px 0;
        text-align: center;
        font-size: 14px;
    }
}
</style>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
    components: {
        vueSeamlessScroll,
    },
    props: {
        analysedata: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            
        };
    },
    computed: {
        optionHover() {
            return {
                hoverStop: false,
                // singleHeight: 44,
                // waitTime: 800,
                step: 0.5
            };
        },
    },
};
</script>